// BackToTopButton.js
import React, { useState, useEffect } from "react";
import { HiArrowUpCircle } from "react-icons/hi2";
import style from "./backbutton.module.css";

const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <>
      {isVisible && (
        <div className={style.backbutton}>
          <HiArrowUpCircle
            onClick={scrollToTop}
            className={style.arrowback}
          ></HiArrowUpCircle>
        </div>
      )}
    </>
  );
};

export default BackToTopButton;
